import React from 'react';

const ResultsCSS = `
.results-screen {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--bg-primary);
  padding: 20px;
  text-align: center;
}

.results-box {
  border: 3px solid var(--text-primary);
  background: var(--bg-secondary);
  padding: 40px 60px;
  max-width: 500px;
  width: 100%;
}

.results-title {
  font-size: 2rem;
  margin-bottom: 30px;
}

.results-title.victory {
  color: var(--success);
  text-shadow: var(--glow-green);
}

.results-title.defeat {
  color: var(--danger);
  text-shadow: var(--glow-red);
}

.results-stats {
  margin: 30px 0;
  font-family: var(--font-terminal);
}

.stat-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px dashed var(--text-dim);
}

.stat-label {
  color: var(--text-secondary);
}

.stat-value {
  color: var(--text-primary);
}

.stat-value.highlight {
  color: var(--warning);
  font-family: var(--font-pixel);
}

.rank-display {
  margin: 30px 0;
  padding: 20px;
  border: 2px solid var(--accent-cyan);
  background: rgba(0, 255, 255, 0.05);
}

.rank-label {
  font-family: var(--font-terminal);
  color: var(--text-secondary);
  margin-bottom: 10px;
}

.rank-value {
  font-family: var(--font-pixel);
  font-size: 1.5rem;
  color: var(--accent-cyan);
  text-shadow: 0 0 10px var(--accent-cyan);
}

.results-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 30px;
  flex-wrap: wrap;
}

.results-buttons .btn {
  padding: 12px 25px;
}
`;

export const GameOverScreen = ({ level, totalLevels, score, stats, rank, onRestart, onTitle }) => {
  return (
    <>
      <style>{ResultsCSS}</style>
      <div className="results-screen">
        <div className="results-box">
          <h1 className="results-title defeat">MISSION FAILED</h1>
          
          <div className="results-stats">
            <div className="stat-row">
              <span className="stat-label">Bounties Completed:</span>
              <span className="stat-value">{stats.bossesDefeated}</span>
            </div>
            <div className="stat-row">
              <span className="stat-label">Threats Neutralized:</span>
              <span className="stat-value">{stats.threatsKilled}</span>
            </div>
            {stats.maxCombo > 1 && (
              <div className="stat-row">
                <span className="stat-label">Max Combo:</span>
                <span className="stat-value">x{stats.maxCombo}</span>
              </div>
            )}
            <div className="stat-row">
              <span className="stat-label">Final Score:</span>
              <span className="stat-value highlight">{score.toLocaleString()}</span>
            </div>
          </div>

          <div className="rank-display">
            <p className="rank-label">SECURITY CLEARANCE</p>
            <p className="rank-value" style={{ color: rank.color }}>{rank.name}</p>
          </div>

          <div className="results-buttons">
            <button className="btn" onClick={onTitle}>[ MAIN MENU ]</button>
            <button className="btn" onClick={onRestart}>[ NEW CONTRACT ]</button>
          </div>
        </div>
      </div>
    </>
  );
};

export const VictoryScreen = ({ score, stats, rank, onRestart, onTitle }) => {
  return (
    <>
      <style>{ResultsCSS}</style>
      <div className="results-screen">
        <div className="results-box">
          <h1 className="results-title victory">CONTRACT COMPLETE</h1>
          
          <div className="results-stats">
            <div className="stat-row">
              <span className="stat-label">Bounties Collected:</span>
              <span className="stat-value">{stats.bossesDefeated}</span>
            </div>
            <div className="stat-row">
              <span className="stat-label">Threats Neutralized:</span>
              <span className="stat-value">{stats.threatsKilled}</span>
            </div>
            {stats.maxCombo > 1 && (
              <div className="stat-row">
                <span className="stat-label">Max Combo:</span>
                <span className="stat-value">x{stats.maxCombo}</span>
              </div>
            )}
            <div className="stat-row">
              <span className="stat-label">Total Bounty:</span>
              <span className="stat-value highlight">{score.toLocaleString()}</span>
            </div>
          </div>

          <div className="rank-display">
            <p className="rank-label">SECURITY CLEARANCE ACHIEVED</p>
            <p className="rank-value" style={{ color: rank.color }}>{rank.name}</p>
          </div>

          <div className="results-buttons">
            <button className="btn" onClick={onTitle}>[ MAIN MENU ]</button>
            <button className="btn" onClick={onRestart}>[ NEW CONTRACT ]</button>
          </div>
        </div>
      </div>
    </>
  );
};
